import React from "react";
import AppButton from "./AppButton";
import AppDialog from "./AppDialog";
import AppDialogBody from "./AppDialogBody";
import AppDialogFooter from "./AppDialogFooter";
import AppDialogHeader from "./AppDialogHeader";

export default function AppConfirmDialog({
  title,
  description,
  subtitle: _subtitle,
  icon = null,
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  confirmIcon = null,
  confirmTone = "default",
  hideCancel = false,
  onConfirm,
  onClose,
  className = "",
  children,
  ...props
}) {
  const resolvedIcon =
    React.isValidElement(icon) && icon.props?.sx?.fontSize == null && icon.props?.fontSize == null
      ? React.cloneElement(icon, {
          sx: {
            ...icon.props.sx,
            fontSize: 18,
          },
        })
      : icon;

  const resolvedFooter = (
    <>
      {!hideCancel ? (
        <AppButton variant="neutral" onClick={onClose}>
          {cancelLabel}
        </AppButton>
      ) : null}
      <AppButton variant={confirmTone === "error" ? "error" : "primary"} onClick={onConfirm}>
        {confirmIcon}
        {confirmLabel}
      </AppButton>
    </>
  );

  return (
    <AppDialog
      {...props}
      showCloseButton
      onClose={onClose}
      className={["ds-dialog--confirm", className].filter(Boolean).join(" ")}
    >
      <AppDialogHeader title={title} visual={resolvedIcon} />
      <AppDialogBody>{children ?? <p className="ds-dialog__message">{description}</p>}</AppDialogBody>
      <AppDialogFooter>{resolvedFooter}</AppDialogFooter>
    </AppDialog>
  );
}
